import { Injectable } from '@angular/core';
import { Stripe } from '@ionic-native/stripe';
import { CheckFormatContainer } from 'model/check-format.model';
import { ApiService } from './api';
import { PurchaseOrder } from 'model/purchase-order';
import { Product, StripePaymentRequest } from 'model/stripe-payment-request.model';
import { RodeoEventRegistration } from 'model/rodeoEventRegistration';

@Injectable()
export class PaymentService {
    private products: Product[];

    constructor(private api: ApiService, /*private stripe: Stripe*/) { }

    makePayment(paymentNonce, itemName, amount, accountId, entryId) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.payment +
                    '/makePayment?itemName=' + itemName +
                    '&amount=' + amount +
                    '&accountId=' + accountId +
                    '&entryId=' + entryId,
                    paymentNonce
                )
                .then(data => resolve(data), error => reject(error));
        });
    }

    getNewStripeConnectLink() {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.payment +
                    '/getNewConnectAccountLink')
                .then(data => resolve(data), error => reject(error));
        });
    }

    getNextGenStripePaymentInfo() {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.payment +
                    '/getNextGenStripePaymentInfo')
                .then(data => resolve(data), error => reject(error));
        });
    }

    getPaymentDetails(secretaryId, transactionId) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.payment +
                    '/getPaymentDetails?secretaryId=' + secretaryId + '&transactionId=' + transactionId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    searchTransactionsByCC(secretaryId, ccDigits) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.payment +
                    '/searchTransactionsByCC?secretaryId=' + secretaryId + '&ccDigits=' + ccDigits)
                .then(data => resolve(data), error => reject(error));
        });
    }

    refundEntry(entryId, unitPrice, transactionId) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.payment +
                    '/refundPayment?entryId=' + entryId +
                    '&amount=' + unitPrice +
                    '&transactionId=' + transactionId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getSettledBatches(secretaryId) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.payment +
                    '/getSettledBatches?secretaryId=' + secretaryId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getTransactionList(secretaryId, batchId) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.payment +
                    '/getTransactionList?secretaryId=' + secretaryId + '&batchId=' + batchId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    async payWithTokenToStripe(token, rodeoId, total): Promise<any> {
        try {
            return await this.api.postWithAuth(`${this.api.endpoints.payment}/payWithTokenToStripe?amount=${total}&rodeoId=${rodeoId}`, token);
        } catch (err) {
            console.error('PaymentService - payWithTokenToStripe', err);
            return [];
        }
    }

    async payStripeWithCardToken(token, secretaryId, total): Promise<any> {
        try {
            return await this.api.postWithAuth(`${this.api.endpoints.payment}/payStripeWithCardToken?amount=${total}&secretaryId=${secretaryId}`, token);
        } catch (err) {
            console.error('PaymentService - payStripeWithCardToken', err);
            return [];
        }
    }

    async getPrintCheckStyles() {
        return this.api.getWithAuth<CheckFormatContainer[]>(`${this.api.endpoints.payment}/GetPrintCheckFormats`);
    }

    async savePrintCheckStyle(request: CheckFormatContainer) {
        return this.api.postWithAuth(`${this.api.endpoints.payment}/SavePrintCheckFormats`, request);
    }

    async deletePrintCheckStyle(id: number) {
        await this.api.deleteWithAuth(`${this.api.endpoints.payment}/DeletePrintCheckFormat?id=${id}`);
    }

    async getOrder(id: number) {
        return this.api.getWithAuth<PurchaseOrder>(`${this.api.endpoints.payment}/getpurchaseorder?id=${id}`);
    }

    async getProducts() {
        if (!this.products) {
            const products = await this.api.getWithAuth<Product[]>(`${this.api.endpoints.payment}/GetProducts`);
            if (products && products.length > 0) {
                this.products = products;
            }
        }
        return this.products;
    }

  async getPaymentInformation(registration: RodeoEventRegistration, paymentMethod = 'stripe') {
    return this.api.postWithAuth<StripePaymentRequest>(`${this.api.endpoints.payment}/GetPaymentDisplayInfoStaff?paymentMethod=${paymentMethod}`, [registration]);
  }
}



// WEBPACK FOOTER //
// ./src/services/payment.service.ts